import { langPickerControll } from './lang-picker';

// ==================================================================================================
//
// Mobile Menu Functionality
//
// ==================================================================================================
const menuMobile = () => {
  let props = { isEnabled : false };
  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.$body          = $('body');
    els.$mobileMenuBtn = $('.js-mobile-menu-btn');
    els.$mobileMenu    = $('.js-mobile-menu');
    els.$mainMenu      = $('.js-main-menu');
    els.$jumpNav       = $('.js-jump-nav');
    els.$closeNav      = $('.js-nav-close-item-screenreader')
  }

  // Add appropriate hover classes to control style
  // on non-hovered nav items
  // ------------------------------------------------
  const toggleMobileMenu = (e) => {
    els.$body.toggleClass('is-modal-open');
    els.$mobileMenuBtn.children('.menu-hamburger').toggleClass('is-open');
    els.$mobileMenu.toggleClass('is-open');
    els.$mainMenu.toggleClass('is-mobile-open');
    els.$jumpNav.toggleClass('is-hidden');

    // if mobile menu is open, make visible to aria for #a11y
    if(els.$mobileMenu.hasClass('is-open')) {
      els.$mobileMenu.attr('aria-hidden', false)
    } else {
      els.$mobileMenu.attr('aria-hidden', true)
    }

    // if close nav button is clicked, set focus on main for #a11y
    if($(e.currentTarget).hasClass('js-nav-close-item-screenreader')) $('.js-main-content').focus()
  }

  // Set up for responsive
  // ------------------------------------------------
  const setupResponsive = () => {
    return {
      'sm' : enable,
      'md' : enable,
      'lg' : disable,
      'xl' : disable
    }
  }

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Add your event handlers here
    els.$mobileMenuBtn.on('click', toggleMobileMenu);
    els.$closeNav.on('click', toggleMobileMenu)

    props.isEnabled = true;

    return;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    els.$mobileMenuBtn.off('click', toggleMobileMenu);
    els.$closeNav.off('click', toggleMobileMenu)
    els.$body.removeClass('is-modal-open');
    els.$mobileMenuBtn.children('.menu-hamburger').removeClass('is-open');
    els.$mobileMenu.removeClass('is-open');
    els.$mainMenu.removeClass('is-mobile-open');
    els.$jumpNav.removeClass('is-hidden');

    props.isEnabled = false;

    return;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren();
    setupResponsive();
    langPickerControll('.lang_picker');
    return;
  }

  return {
    init,
    enable,
    disable,
    responsiveCallbacks: setupResponsive()
  };
}

export default menuMobile;
